import { InputAdornment, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { useEffect, useState } from 'react'
import icDelete from '../../assets/ic_delete3.png'
import { formatCurrency } from '../../library/Util';
import DateFnsUtils from "@date-io/date-fns";
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from '../api';

export default function ListDataRadiologi(props) {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [listRadiologi, setListRadiologi] = useState([])
    const [pickRadiologi, setPickRadiologi] = useState(null)
    const [listType, setListType] = useState([])
    const [pickTypeRadiologi, setPickTypeRadiologi] = useState(null)
    let total = 0

    const forceUpdate = React.useReducer(bool => !bool)[1];

    useEffect(() => {
        console.log(props)
        if (props.data.length > 0) {
            setData(props.data)
            forceUpdate()
        }
        setTimeout(() => {
            setLoading(false)
        }, 200);
        getFacilityByID()
        getEksternalCode()
        if (props.pickTypeRadiologi) {
            setPickTypeRadiologi(props.pickTypeRadiologi)
        }
        if (props.pickRadiologi) {
            setPickRadiologi(props.pickRadiologi)
        }
    }, [])

    const getFacilityByID = () => {
        api.create().getFacilityByCategoriID("Radiology").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setListRadiologi(response.data.data)
                    if (data.length > 0) {
                        data.map((item) => {
                            getEksternalCode(item.id)
                        })
                    }
                }
            }
        })
    }

    const getEksternalCode = (id) => {
        console.log(id);
        api.create().getListSubFacilityByFacility(id).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setListType(response.data.data)
                }
            }
        })
    }

    return (
        <div>
            <div style={{ padding: '0 20px' }}>
                <div style={{ display: 'flex' }}>
                    <Typography style={{ fontSize: 14, color: '#a4a4a4', textAlign: 'left', marginRight: 10 }}>Lokasi Fasilitas : </Typography>
                    <Autocomplete
                        options={listRadiologi}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, newInputValue) => {
                            setPickRadiologi(newInputValue)
                            props.setPickRadiologi(newInputValue)
                            setPickTypeRadiologi(null)
                            getEksternalCode(newInputValue && newInputValue.id)
                            forceUpdate()
                        }}
                        style={{ width: '20%', margin: -7 }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                required={true}
                                InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                            />
                        }
                        value={pickRadiologi}
                    />

                    <Typography style={{ fontSize: 14, color: '#a4a4a4', textAlign: 'left', marginLeft: 30, marginRight: 24 }}>Tipe Radiologi : </Typography>
                    <Autocomplete
                        options={listType}
                        disabled={pickRadiologi === null ? true : false}
                        getOptionLabel={(option) => option.name}
                        onChange={(event, newInputValue) => {
                            setPickTypeRadiologi(newInputValue)
                            props.setPickTypeRadiologi(newInputValue)
                            forceUpdate()
                        }}
                        style={{ width: '20%', margin: -7 }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                required={true}
                                InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
                                InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                            />
                        }
                        value={pickTypeRadiologi}
                    />
                </div>
            </div>
            {!loading && data.length > 0 ?
                data.map((item, index) => {
                    total += Number(item[3])
                    return (
                        <div style={{ padding: '0 20px' }}>
                            {index === 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: 20 }}>
                                    <div style={{ width: '25%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan</Typography>
                                    </div>
                                    <div style={{ width: '8%' }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Qty</Typography>
                                    </div>
                                    <div style={{ width: '20%', marginRight: 20 }}>
                                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}> Amount</Typography>
                                    </div>
                                    <div style={{ width: '30%', display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ marginRight: 20 }}>
                                            <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Total Amount</Typography>
                                        </div>
                                        <div style={{ width: 60 }}>
                                            <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'center' }}>Aksi</Typography>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div >
                                <div style={{ backgroundColor: '#e7ffec', borderBottomLeftRadius: index === data.length - 1 && 20, borderBottomRightRadius: index === data.length - 1 && 20, borderTopLeftRadius: index === 0 && 20, borderTopRightRadius: index === 0 && 20, padding: '0 20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderBottom: index !== data.length - 1 ? '2px solid #9adaa8' : '' }}>
                                        <div style={{ width: '25%' }}>
                                            <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{item[0]}</Typography>
                                        </div>
                                        <div style={{ width: '8%' }}>
                                            <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>{item[1]}</Typography>
                                        </div>
                                        <div style={{ width: '20%', marginRight: 20 }}>
                                            <Typography style={{ fontSize: 12, color: 'black', textAlign: 'left' }}>Rp. {formatCurrency(item[2])}</Typography>
                                        </div>
                                        <div style={{ width: '30%', display: 'flex', justifyContent: 'space-between' }}>
                                            <div style={{ marginRight: 20 }}>
                                                <Typography style={{ fontSize: 12, color: 'black', textAlign: 'right' }}>Rp. {formatCurrency(item[3])}</Typography>
                                            </div>
                                            <div style={{ width: 60, alignSelf: 'center', display: 'flex', justifyContent: 'center' }}>
                                                <img
                                                    onClick={() => {
                                                        props.deleteRadiologi(item, index)
                                                        // item.val.length === 0 ?
                                                        //     data.splice(index, 0) :
                                                        //     data[index].val.splice(idx, 0)
                                                        // console.log(data);
                                                        // forceUpdate()
                                                    }}
                                                    src={icDelete} style={{ width: 20, height: 20, cursor: 'pointer' }} />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            {data.length - 1 === index && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: 13 }}>
                                    <div>
                                        <Typography style={{ fontSize: 14, color: 'black', textAlign: 'left' }}>Total Biaya {item.name}</Typography>
                                    </div>
                                    <div style={{ width: '30.5%' }}>
                                        <Typography style={{ fontSize: 14, color: 'black', textAlign: 'left' }}>Rp. {formatCurrency(total)}</Typography>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                })
                :
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, padding: '0 20px' }}>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Keterangan</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Qty</Typography>
                    </div>
                    <div style={{ width: '10%', }}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Amount</Typography>
                    </div>
                    <div style={{}}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Total Amount</Typography>
                    </div>
                    <div style={{ width: 60 }}>
                        <Typography style={{ fontSize: 14, color: '#278863', textAlign: 'left' }}>Aksi</Typography>
                    </div>
                </div>
            }
        </div>
    )
}
